import { encode } from 'html-entities';

export const isValidUrl = (url: string) => {
  const encodedUrl = encode(url);
  let urlvalidated;
  try {
    urlvalidated = new URL(encodedUrl);
  } catch {
    return false;
  }
  return urlvalidated.protocol === 'https:';
};
